import ta from 'thinkingdata-browser'

// 沿用支付站的 $log；埋点失败不影响兑换、领奖和页面跳转。
export const createShoppingTracker = (log) => {
  const track = (event, context, properties = {}) => {
    try {
      // 与后端统一用角色 ID 绑定 SDK 身份，匿名访问清除上次绑定。
      if (context.account_id) ta.login(context.account_id)
      else ta.logout()
      log.track(event, { ...context, ...properties })
    } catch (error) {
      console.error('double11 track error', error)
    }
  }

  return {
    pageEntry: context => track('double11_page_entry', context, { page_source: 2 }),
    login: context => track('double11_login', context, { page_source: 2 }),
    exchange: (context, goods, count) => track('double11_exchange', context, {
      goods_id: goods.goodsCode,
      goods_name: goods.propName,
      goods_price: Number(goods.price),
      goods_count: count,
    }),
    milestones: (context, milestones = []) => {
      if (!Array.isArray(milestones)) return
      milestones.forEach(item => track('double11_get_milestone', context, {
        milestone_progress: Number(item.targetSpent),
        reward_detail: JSON.stringify((item.props || []).map(prop => ({
          id: String(prop.propId),
          count: Number(prop.propCount),
        }))),
      }))
    },
    rechargeClick: context => track('double11_recharge_click', context),
  }
}
